import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import WorkCard from "@/components/feature/WorkCard";
import SectionHeading from "@/components/base/SectionHeading";
import HeroCarousel from "@/pages/home/components/HeroCarousel";
import QuickEntries from "@/pages/home/components/QuickEntries";
import LatestNews from "@/pages/home/components/LatestNews";
import { movies, tvShows } from "@/mocks/works";

const stats = [
  { value: "20,000+", label: "影视资源", highlight: false },
  { value: "100+", label: "每日更新", highlight: false },
  { value: "6 大", label: "分类维度", highlight: false },
  { value: "98%", label: "高清覆盖", highlight: true },
];

export default function Home() {
  return (
    <div className="flex min-h-screen flex-col bg-background-50">
      <SiteHeader />

      <main className="flex-1">
        <HeroCarousel />
        <QuickEntries />

        {/* 热门电影 */}
        <section className="mx-auto mt-14 max-w-site px-4 md:px-6">
          <SectionHeading
            eyebrow="热门推荐"
            title="热门电影"
            desc="本周播放量领先的高分电影，覆盖科幻、动作、悬疑等多种类型"
            moreTo="/category/movie"
            moreLabel="更多电影"
          />
          <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6">
            {movies.map((work) => (
              <WorkCard key={work.id} work={work} />
            ))}
          </div>
        </section>

        {/* 热门电视剧 */}
        <section className="mx-auto mt-14 max-w-site px-4 md:px-6">
          <SectionHeading
            eyebrow="追剧必备"
            title="热门电视剧"
            desc="正在热播与口碑长青的剧集，全集上线，方便连续追看"
            moreTo="/category/tv"
            moreLabel="更多电视剧"
          />
          <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6">
            {tvShows.map((work) => (
              <WorkCard key={work.id} work={work} />
            ))}
          </div>
        </section>

        {/* 最新资讯 */}
        <section className="mx-auto mt-14 max-w-site px-4 md:px-6">
          <SectionHeading
            eyebrow="影视动态"
            title="最新影视资讯"
            desc="影视新闻、深度评论与专题观察，掌握行业脉动"
            moreTo="/news"
            moreLabel="全部资讯"
          />
          <LatestNews />
        </section>

        {/* 网站简介 */}
        <section className="mt-16 bg-background-100">
          <div className="mx-auto grid max-w-site grid-cols-1 items-center gap-10 px-4 py-14 md:px-6 lg:grid-cols-2">
            <div className="order-2 lg:order-1">
              <span className="inline-block rounded bg-secondary-100 px-2 py-0.5 text-xs font-medium text-secondary-900">
                关于 91看片
              </span>
              <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
                高清影视与资讯，一站直达
              </h2>
              <p className="mt-4 text-sm leading-7 text-foreground-600">
                91看片聚焦高清电影、电视剧的在线观看与影视资讯服务。我们以清晰的内容分类、多维度的筛选条件和实时的热门榜单，帮助你在海量作品里快速找到想看的那一部，也为影视爱好者提供权威、及时的行业资讯。
              </p>
              <ul className="mt-5 space-y-2.5">
                {[
                  "海量影视资源，按地区、年份、类型多维筛选",
                  "热门度、新上架、评分多角度排序",
                  "影视资讯每日更新，深度与时效兼顾",
                ].map((text) => (
                  <li key={text} className="flex items-start gap-2 text-sm text-foreground-700">
                    <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-primary-100 text-primary-700">
                      <i className="ri-check-line text-xs"></i>
                    </span>
                    {text}
                  </li>
                ))}
              </ul>
              <div className="mt-7 grid grid-cols-2 gap-4 sm:grid-cols-4">
                {stats.map((stat) => (
                  <div key={stat.label}>
                    <p
                      className={`font-heading text-2xl font-black ${
                        stat.highlight ? "text-accent-600" : "text-primary-700"
                      }`}
                    >
                      {stat.value}
                    </p>
                    <p className="mt-1 text-xs text-foreground-500">{stat.label}</p>
                  </div>
                ))}
              </div>
            </div>
            <div className="order-1 lg:order-2">
              <div className="h-[280px] w-full overflow-hidden rounded-lg md:h-[380px]">
                <img
                  src="https://readdy.ai/api/search-image?query=Modern%20home%20cinema%20corner%20with%20a%20large%20screen%20showing%20abstract%20colorful%20gradient%2C%20comfortable%20seating%20and%20soft%20ambient%20lighting%2C%20cinematic%20warm%20and%20teal%20tones%2C%20cozy%20premium%20streaming%20atmosphere%2C%20editorial%20interior%20photography%2C%20high%20detail&width=1000&height=750&seq=home-intro-01&orientation=landscape"
                  alt="91看片 高清影视观影体验"
                  title="91看片 - 高清影视在线观看与影视资讯平台"
                  className="h-full w-full object-cover object-top"
                />
              </div>
            </div>
          </div>
        </section>
      </main>

      <SiteFooter />
    </div>
  );
}